import { Settings } from "../../../Settings";
import GridTile from "../../grid/GridTile";
import Vector from "../../math/Vector";
import Character from "../../character/Character";
import PathPlan from "./PathPlan";

export default class PathPlanJumpUpRight extends PathPlan {
    /**
     * @param {GridTile} startTile 
     * @param {GridTile} endTile 
     * @param {number} pathSteps
     */
    constructor(startTile, endTile, pathSteps) {
        super(startTile, endTile, pathSteps);

        /**
         * @constant
         * @private
         * @type {Vector}
         */
        this.jumpCoordinate = new Vector(0, 0);
        /**
         * @private
         * @type {Vector}
         */
        this.landCoordinate = new Vector(0, 0);
    }

    /**
     * @param {Character} character 
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     * @return {boolean} True when the step is completed.
     */
    executePlan(character, frameTimeRatio, turnStart) {

        // jump pixel: right edge of start tile
        // land pixel: left edge of end tile

        this.jumpCoordinate.copy(this.startTile.origin);
        this.jumpCoordinate.addXY(Settings.tile.halfSize, 0);
        const jumpCoordinateX = this.jumpCoordinate.x;
        
        /////////////////////////////////////////////
        // Walk to jump coordinate
        /////////////////////////////////////////////

        if (character.position.worldCoordinateCenter.x < jumpCoordinateX) {
            this.walkRightToCenterX(character, frameTimeRatio, jumpCoordinateX);
            return false;
        }

        /////////////////////////////////////////////
        // Jump up & Right
        /////////////////////////////////////////////

        // Land center of end tile
        this.landCoordinate.copy(this.endTile.origin);
        this.landCoordinate.addXY(Settings.tile.halfSize, 0);
        
        if (character.position.worldCoordinateCenter.x < this.landCoordinate.x) {
            this.jumpUpAndRight(character, frameTimeRatio, this.jumpCoordinate, this.landCoordinate);
            return false;
        }

        this.assertEndTileReached(character, this.endTile);

        return true;
    }
    
    /**
     * @returns {String}
     */
    toString() {
        return 'JumpUpRight(' + this.pathSteps + ')';
    }
}